import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Card, Upload, Icon, Button, message } from 'antd'

import joinUsService from './../services/joinus.service'
import recruitmentsService from './../services/recruitments.service'

const FormItem = Form.Item

const SupportingDocumentsStep = ({
  form,
  profile,
  supportingDocumentsData,
  handleFileUploads,
  handleFileDownload,
}) => {
  const { getFieldDecorator } = form
  const [files, setFiles] = useState(supportingDocumentsData)
  const currentPath = window.location.pathname

  useEffect(() => {
    setFiles(supportingDocumentsData)
  }, [supportingDocumentsData])

  const curriculumVitaeUploadOptions = {
    name: 'Curriculum Vitae',
    openFileDialogOnClick: true,
    multiple: false,
    onChange(info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        console.log('INFO', info)
        message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    async customRequest(options) {
      let recruitId = ''

      if (supportingDocumentsData && supportingDocumentsData._id) {
        recruitId = supportingDocumentsData._id
      } else {
        recruitId = 'recruitId'
      }

      if (!currentPath.includes('joinus')) {
        const fileCV = await recruitmentsService.uploadRecruitmentFile(
          options,
          recruitId,
          'fileCV'
        )

        handleFileUploads(fileCV, 'fileCV')
      } else {
        const fileCV = await joinUsService.uploadFile(
          options,
          recruitId,
          'fileCV'
        )

        handleFileUploads(fileCV, 'fileCV')
      }
    },
  }

  const coverLetterUploadOptions = {
    name: 'Cover Letter',
    openFileDialogOnClick: true,
    multiple: false,
    onChange(info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        console.log('INFO', info)
        message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    async customRequest(options) {
      let recruitId = ''

      if (supportingDocumentsData && supportingDocumentsData._id) {
        recruitId = supportingDocumentsData._id
      } else {
        recruitId = 'recruitId'
      }

      if (!currentPath.includes('joinus')) {
        const fileCL = await recruitmentsService.uploadRecruitmentFile(
          options,
          recruitId,
          'fileCL'
        )

        handleFileUploads(fileCL, 'fileCL')
      } else {
        const fileCL = await joinUsService.uploadFile(
          options,
          recruitId,
          'fileCL'
        )

        handleFileUploads(fileCL, 'fileCL')
      }
    },
  }

  // const reportOfInterviewUploadOptions = {
  //   name: 'Report of Interview',
  //   openFileDialogOnClick: true,
  //   multiple: false,
  //   onChange(info) {
  //     const status = info.file.status
  //     if (status !== 'uploading') {
  //       console.log(info.file, info.fileList)
  //     }
  //     if (status === 'done') {
  //       console.log('INFO', info)
  //       message.success(`${info.file.name} file uploaded successfully.`)
  //     } else if (status === 'error') {
  //       message.error(`${info.file.name} file upload failed.`)
  //     }
  //   },
  //   async customRequest(options) {
  //     let recruitId = ''

  //     if (supportingDocumentsData && supportingDocumentsData._id) {
  //       recruitId = supportingDocumentsData._id
  //     } else {
  //       recruitId = 'recruitId'
  //     }

  //     if (!currentPath.includes('joinus')) {
  //       const fileRI = await recruitmentsService.uploadRecruitmentFile(
  //         options,
  //         recruitId,
  //         'fileRI'
  //       )

  //       handleFileUploads(fileRI, 'fileRI')
  //     } else {
  //       const fileRI = await joinUsService.uploadFile(
  //         options,
  //         recruitId,
  //         'fileRI'
  //       )

  //       handleFileUploads(fileRI, 'fileRI')
  //     }
  //   },
  // }

  if (supportingDocumentsData) {
    return (
      <Card title="Documents" type="inner">
        <Row>
          <Col span={24}>
            <FormItem
              label="Curriculum Vitae"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              {getFieldDecorator('fileCV', {
                valuePropName: 'file',
              })(
                <React.Fragment>
                  <Upload {...curriculumVitaeUploadOptions}>
                    <Button>
                      <Icon type="upload" /> Click to Upload
                    </Button>
                  </Upload>
                  <div
                    style={
                      files && files.fileCV
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {files && files.fileCV ? (
                      <a
                        href
                        onClick={() => {
                          handleFileDownload(
                            files.fileCV.originalname,
                            files._id,
                            files.fileCV.fileType
                          )
                        }}
                      >
                        {files.fileCV.originalname}
                      </a>
                    ) : (
                      ''
                    )}
                  </div>
                </React.Fragment>
              )}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem
              label="Cover Letter"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              {getFieldDecorator('fileCL', {
                valuePropName: 'file',
              })(
                <React.Fragment>
                  <Upload {...coverLetterUploadOptions}>
                    <Button>
                      <Icon type="upload" /> Click to Upload
                    </Button>
                  </Upload>
                  <div
                    style={
                      files && files.fileCL
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {files && files.fileCL ? (
                      <a
                        href
                        onClick={() => {
                          handleFileDownload(
                            files.fileCL.originalname,
                            files._id,
                            files.fileCL.fileType
                          )
                        }}
                      >
                        {files.fileCL.originalname}
                      </a>
                    ) : (
                      ''
                    )}
                  </div>
                </React.Fragment>
              )}
            </FormItem>
          </Col>
        </Row>
        {/* <Row>
          <Col span={24}>
            <FormItem
              label="Report of Interview"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              {getFieldDecorator('fileRI', {
                valuePropName: 'file',
              })(
                <Upload {...reportOfInterviewUploadOptions}>
                  <Button>
                    <Icon type="upload" /> Click to Upload
                  </Button>
                  <div
                    style={
                      files && files.fileRI
                        ? { display: 'none' }
                        : { display: 'block' }
                    }
                  >
                    {files && files.fileRI ? files.fileRI.originalname : ''}
                  </div>
                </Upload>
              )}
            </FormItem>
          </Col>
        </Row> */}
      </Card>
    )
  }

  return (
    <Card title="Documents" type="inner">
      <Row>
        <Col span={24}>
          <FormItem
            label="Curriculum Vitae"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            {getFieldDecorator('fileCV', {
              valuePropName: 'file',
            })(
              <React.Fragment>
                <Upload {...curriculumVitaeUploadOptions}>
                  <Button>
                    <Icon type="upload" /> Click to Upload
                  </Button>
                </Upload>
                <div
                  style={
                    files && files.fileCV
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  {files && files.fileCV ? (
                    <a
                      href
                      onClick={() => {
                        handleFileDownload(
                          files.fileCV.originalname,
                          files._id,
                          files.fileCV.fileType
                        )
                      }}
                    >
                      {files.fileCV.originalname}
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </React.Fragment>
            )}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <FormItem
            label="Cover Letter"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            {getFieldDecorator('fileCL', {
              valuePropName: 'file',
            })(
              <React.Fragment>
                <Upload {...coverLetterUploadOptions}>
                  <Button>
                    <Icon type="upload" /> Click to Upload
                  </Button>
                </Upload>
                <div
                  style={
                    files && files.fileCL
                      ? { display: 'block' }
                      : { display: 'none' }
                  }
                >
                  {files && files.fileCL ? (
                    <a
                      href
                      onClick={() => {
                        handleFileDownload(
                          files.fileCL.originalname,
                          files._id,
                          files.fileCL.fileType
                        )
                      }}
                    >
                      {files.fileCL.originalname}
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </React.Fragment>
            )}
          </FormItem>
        </Col>
      </Row>
      {/* <Row>
        <Col span={24}>
          <FormItem
            label="Report of Interview"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            {getFieldDecorator('fileRI', {
              valuePropName: 'file',
            })(
              <Upload {...reportOfInterviewUploadOptions}>
                <Button>
                  <Icon type="upload" /> Click to Upload
                </Button>
              </Upload>
            )}
          </FormItem>
        </Col>
      </Row> */}
    </Card>
  )
}

export default SupportingDocumentsStep
